var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcaseSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M18,4c0-1.104,0.896-2,2-2h24c1.104,0,2,0.896,2,2v9h-2V5c0-0.553-0.447-1-1-1H21c-0.553,0-1,0.447-1,1v8 h-2V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60,13H48V4c0-2.211-1.789-4-4-4H20c-2.211,0-4,1.789-4,4v9H4c-2.211,0-4,1.789-4,4v43c0,2.211,1.789,4,4,4 h56c2.211,0,4-1.789,4-4V17C64,14.789,62.211,13,60,13z M18,4c0-1.104,0.896-2,2-2h24c1.104,0,2,0.896,2,2v9h-2V5 c0-0.553-0.447-1-1-1H21c-0.553,0-1,0.447-1,1v8h-2V4z M42,6v7H22V6H42z M62,60c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V42h10 v5c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1v-5h24v5c0,0.553,0.447,1,1,1h6c0.553,0,1-0.447,1-1v-5h10V60z M14,46v-4v-2v-4h4v4v2 v4H14z M46,46v-4v-2v-4h4v4v2v4H46z M62,40H52v-5c0-0.553-0.447-1-1-1h-6c-0.553,0-1,0.447-1,1v5H20v-5c0-0.553-0.447-1-1-1h-6 c-0.553,0-1,0.447-1,1v5H2V17c0-1.104,0.896-2,2-2h56c1.104,0,2,0.896,2,2V40z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 36,
    fill: "#F9EBB2",
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 36,
    fill: "#F9EBB2",
    width: 4,
    height: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#45AAB8",
    d: "M60,62c1.104,0,2-0.896,2-2V42H52v5c0,0.553-0.447,1-1,1h-6c-0.553,0-1-0.447-1-1v-5H20v5 c0,0.553-0.447,1-1,1h-6c-0.553,0-1-0.447-1-1v-5H2v18c0,1.104,0.896,2,2,2H60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45AAB8",
    d: "M60,15H4c-1.104,0-2,0.896-2,2v23h10v-5c0-0.553,0.447-1,1-1h6c0.553,0,1,0.447,1,1v5h24v-5 c0-0.553,0.447-1,1-1h6c0.553,0,1,0.447,1,1v5h10V17C62,15.896,61.104,15,60,15z"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60,62c1.104,0,2-0.896,2-2V42H52v5c0,0.553-0.447,1-1,1h-6c-0.553,0-1-0.447-1-1v-5H20v5 c0,0.553-0.447,1-1,1h-6c-0.553,0-1-0.447-1-1v-5H2v18c0,1.104,0.896,2,2,2H60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseSvgrepoCom);
export default __webpack_public_path__ + "static/media/briefcase-svgrepo-com.347989722d6ca0c08b43cf5ea052bca9.svg";
export { ForwardRef as ReactComponent };